import classNames from 'classnames';
import React, { useState } from 'react';

import { CheckmarkAnimation } from '@eika/checkmark-animation';
import { Loader } from '@eika/loader';
import { Modal } from '@eika/modal';

import './SigningModal.scss';

interface SigningModalProps {
    isSigning: boolean;
    success: boolean;
    taskUrl: string;
    setShowModal: React.Dispatch<boolean>;
    onCloseModal: () => void;
}
const SigningModal = ({ isSigning, taskUrl, success, setShowModal, onCloseModal }: SigningModalProps) => {
    const [loading, setLoading] = useState(true);
    return (
        <Modal
            open={isSigning}
            setOpen={setShowModal}
            onClose={onCloseModal}
            size="wide"
            contentClassName="signing-modal"
        >
            {loading && !success && <Loader />}
            {success ? (
                <CheckmarkAnimation className="signing-modal__success-animation" />
            ) : (
                <iframe
                    title="Signering"
                    className={classNames('signing-modal__iframe', {
                        'signing-modal__iframe--loading': loading,
                    })}
                    src={taskUrl}
                    onLoad={() => setLoading(false)}
                />
            )}
        </Modal>
    );
};

export default SigningModal;
